import * as React from 'react'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import useTheme from '@mui/material/styles/useTheme'
import useMediaQuery from '@mui/material/useMediaQuery'

import { AutoCloseInfoTooltip } from './AutoCloseInfoTooltip'

interface Props {
  label: string
  name: string
  checked: boolean
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void
  disabled?: boolean
  tooltip?: string
  dataTestId?: string
}

export const ClosingRequirementCheckbox: React.FC<Props> = ({
  label,
  name,
  checked,
  onChange,
  disabled,
  tooltip,
  dataTestId,
}) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const checkboxLabelSx = {
    '& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
      fontSize: isDesktop ? 24 : 28,
    },
    '& .MuiFormControlLabel-label': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
    maxWidth: '100%',
  }

  return (
    <Box
      sx={{
        ...(tooltip && {
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }),
        width: '100%',
        maxWidth: '100%',
      }}
    >
      <FormControlLabel
        sx={tooltip ? { ...checkboxLabelSx, mr: 0, mb: 0 } : checkboxLabelSx}
        label={label}
        control={
          <Checkbox
            color="primary"
            checked={checked}
            name={name}
            onChange={onChange}
            disabled={disabled}
            inputProps={
              dataTestId
                ? ({
                    'data-test-id': dataTestId,
                  } as React.InputHTMLAttributes<HTMLInputElement>)
                : undefined
            }
          />
        }
      />
      {tooltip && <AutoCloseInfoTooltip title={tooltip} />}
    </Box>
  )
}
